import { motion } from "framer-motion";
import { PROCESS } from "./data";
import { Eyebrow, MaskLines, EASE } from "./motion";

export const Process = () => (
  <section data-testid="process-section" className="relative border-t border-white/10 bg-[#121212] py-24 lg:py-32">
    <div className="mx-auto max-w-[1440px] px-5 lg:px-12">
      <Eyebrow index="04">How it starts</Eyebrow>
      <MaskLines className="mt-6 font-display text-4xl font-black uppercase leading-[0.95] tracking-[-0.03em] text-white sm:text-5xl lg:text-6xl" lines={["From first call", <span className="text-zinc-400">to spotless routine.</span>]} />
      <div className="mt-16 grid gap-px overflow-hidden rounded-[22px] border border-white/10 bg-white/10 sm:grid-cols-2 lg:grid-cols-4">
        {PROCESS.map((p, i) => (
          <motion.div
            key={p.n}
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.15 }}
            transition={{ duration: 0.8, delay: i * 0.1, ease: EASE }}
            data-testid={`process-step-${p.n}`}
            className="group relative bg-[#121212] p-8 transition-colors duration-500 hover:bg-[#171717]"
          >
            <span className="absolute left-0 top-0 h-[2px] w-0 bg-brand-400 transition-[width] duration-700 group-hover:w-full" />
            <span className="font-display text-6xl font-black text-white/10 transition-colors duration-500 group-hover:text-brand-400/80">{p.n}</span>
            <h3 className="mt-10 font-display text-2xl font-bold text-white">{p.title}</h3>
            <p className="mt-3 text-sm leading-relaxed text-zinc-300">{p.text}</p>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);
